import { useQuery } from '@tanstack/react-query';
import { savApi } from '../api/savApi';

export const useSavDetail = (id: number) => {
  const savQuery = useQuery({
    queryKey: ['sav-detail', id],
    queryFn: () => savApi.getById(id),
    staleTime: 1000 * 30,
  });

  const statusesQuery = useQuery({
    queryKey: ['sav-detail', id, 'virtual-statuses'],
    queryFn: () => savApi.getVirtualStatuses(id),
    staleTime: 1000 * 30,
  });

  return {
    sav: savQuery.data ?? null,
    virtualStatuses: statusesQuery.data ?? [],
    isLoading: savQuery.isLoading || statusesQuery.isLoading,
    error: (savQuery.error as Error)?.message || (statusesQuery.error as Error)?.message || null,
  };
};
